import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommentFormComponent } from "../commentForm/commentForm.component";
import { CommentEstablishmentService } from '../service/comment.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'comment-delivery',
  imports: [CommonModule, CommentFormComponent],
  templateUrl: './commentDelivery.component.html',
  styleUrl: './commentDelivery.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentDeliveryComponent {
  @Input() shopingCart: string = '';
  @ViewChild('commentForm') commentForm!: CommentFormComponent;
  @Output() FormSend = new EventEmitter<boolean>();
  constructor(
    private commentEstablishmentService: CommentEstablishmentService,
  ) {

  }
  OnSubmit(comment: { comment: string, starts: number, shopingCart: string }) {
    this.commentEstablishmentService.commentDelivery(comment).pipe(
      finalize(() => {
        this.commentForm.resetLoading();
      })
    ).subscribe({
      next: (response) => {
       
        this.FormSend.emit(true);
      },
      error: (error) => {
        console.error('Error al enviar comentario:', error);
      }
    });
  }

}
